<template>
    <v-data-table
      :headers="headers"
      :items="listado">
      <template
        v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano
          :fecha="item.createdAt">
        </fecha-humano>
      </template>
      <template v-slot:[`item.tipo`]="{ item }">
            <v-chip class="mx-2" small
            :color="tipoLista.find(({tipo}) => tipo=== item.tipo).color">
            {{ tipoLista.find(({tipo}) => tipo=== item.tipo).nombre }}
            </v-chip>
      </template>
      <template v-slot:[`item.correoElectronico`]="{ item }">
        <a :href="`mailto:${item.correoElectronico}`">{{ item.correoElectronico }}</a>
      </template>
      <template v-slot:[`item.celular`]="{ item }">
        <a :href="`tel:${item.celular}`">{{ item.celular }}</a>
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
      <v-tooltip
        top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="editar(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <span>Editar</span>
      </v-tooltip>
      <v-tooltip
        top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="borrar(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <span>Borrar</span>
      </v-tooltip>
    </template>
    </v-data-table>
</template>

<script>
import FechaHumano from '@/components/FechaHumano.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ContratoListadoDirectorio',
  props: {
    listado: {
      type: Array,
      required: true,
    },
  },
  components: {
    FechaHumano,
  },
  data() {
    return {
      headers: [
        {
          text: 'Nombre', align: 'start', sortable: false, value: 'nombre',
        },
        {
          text: 'Tipo', align: 'center', value: 'tipo', sortable: false, width: '50px',
        },
        {
          text: 'Puesto', align: 'start', sortable: false, value: 'puesto',
        },
        {
          text: 'Correo Electrónico', align: 'start', sortable: false, value: 'correoElectronico',
        },
        {
          text: '# Teléfono', align: 'start', sortable: false, value: 'celular',
        },
        {
          text: '', align: 'end', width: '150', value: 'acciones',
        },
      ],
      tipoLista: [
        {
          tipo: 1,
          nombre: 'DEPENDENCIA',
          color: 'base4',
        },
        {
          tipo: 2,
          nombre: 'CONTRATISTA',
          color: 'verde1',
        },
        {
          tipo: 3,
          nombre: 'SUPERVISION EXTERNA',
          color: 'azul1',
        },
        {
          tipo: 4,
          nombre: 'OTROS',
          color: 'naranja2',
        },

      ],
    };
  },
  methods: {
    editar(directorio) {
      eventBus.$emit('editar-directorio-contrato', directorio);
    },
    borrar(directorio) {
      eventBus.$emit('eliminar-directorio-contrato', directorio);
    },
  },
};
</script>

<style lang="scss">

</style>
